<script>
import { $config } from "@/config";

export default {
  mounted() {
    window.location.href = $config['url'] + 'quizs'
  }
}
</script>